<template>
  <div class="xq-table">
    <el-table :row-key="rowKey" ref="table" id="tableList" class="xqTableList" header-cell-class-name='header-background' :height="tableHeight" stripe border size="small" fit :highlight-current-row="canDBClick" v-loading="loading" :data="handleIndex(rows)" :row-style="{cursor: canDBClick?'pointer':''}" :header-cell-style="{background:'linear-gradient(to top, #ededed, #ffffff)'}" :cell-style="cellStyle" :row-class-name="tableRowClassName" @row-click="(row) => {
       if (onRowClick) {
         if (showExpand) { handleRowExpand(row) }
          handleKeyEvent(row)
          onRowClick(row)
          }
      }" @row-dblclick="(row) => {
        if (canDBClick === true)
          if (onRowDBClick) {
            handleKeyEvent(row)
            onRowDBClick(row)
          }
      }" @selection-change="onSelection" @select="onSelect" :show-summary="showSummary" :summary-method="summaryMethod">
      <el-table-column v-if="showExpand" fixed align="center" type="expand" width="40">
        <template slot-scope="props">
          <slot name="expand" :row="props.row">
          </slot>
        </template>
      </el-table-column>
      <el-table-column v-if="showSelection" align="center" type="selection" width="40" :selectable="checkSelectable" :reserve-selection="reserveSelection" />
      <el-table-column v-if="showIndex && !continuous" label="序号" type="index" align="center" width="55" class-name="xqTableIndex" />
      <el-table-column v-if="showIndex && continuous" label="序号" prop="index" align="center" width="55" class-name="xqTableIndex" />
      <template v-for="(col,index) in cols">
        <el-table-column v-if="col.kind === 'img'" :width="col.width" :key="index" :type="col.type" :fixed="col.fixed" :align="col.align" :label="col.label" :class-name="col.class" :label-class-name="col.labelClass">
          <template slot-scope="scope">
            <img style="width:50px; height: 50px" :src="scope.row[col.prop]" />
          </template>
        </el-table-column>
        <el-table-column v-else-if="col.prop === 'handle'" :width="col.width" :key="index" :type="col.type" :fixed="col.fixed || 'right'" :align="col.align" :label="col.label" :class-name="col.class" :label-class-name="col.labelClass">
          <template slot-scope="scope">
            <el-button class="tabel-button" v-for="(handle, i) in col.handle" :key="i" @click.stop="handle.handle(scope.row)" type="text" size="small" :disabled="handleDisabled(handle.disabled, scope.row)" :style="handleStyle(handle.style, scope.row)">{{handleTitle(handle.title, scope.row)}}</el-button>
          </template>
        </el-table-column>
        <el-table-column v-else :width="['patientPhone', 'contactPhone','phone', 'qq'].includes(col.prop) ? 120 : ['billTime','createTime','cureTime','uploadTime'].includes(col.prop) ?150: col.width" :show-overflow-tooltip='col.overflow' :key="index" :type="col.type" :fixed="col.fixed" :align="col.align" :label="col.label" :prop="col.prop" :class-name="col.class" :label-class-name="col.labelClass" :sortable="col.sortable" :formatter="col.formatter" />
      </template>
    </el-table>
    <el-pagination v-if="showPager" small background layout="total, prev, pager, next, jumper" :current-page.sync="currentPage" :total="count" :page-size="size" @size-change="onPaginationSizeChange" @current-change="onPaginationPageChange" />
  </div>
</template>
<script>
export default {
  name: 'XGTable',
  props: {
    rowKey: {
      type: [String, Number],
      default: ''
    },
    overflow: {
      type: Boolean,
      default: false
    },
    // 显示选择框
    showSelection: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    // 显示序号
    showIndex: {
      type: Boolean,
      default: () => {
        return true
      }
    },
    setheight: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    tabsHeight: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    haveTopBtn: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    detailTabsHeight: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    dialogHeight: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    totalHeight: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    canDBClick: {
      type: Boolean,
      default: () => {
        return true
      }
    },
    cellStyle: {
      type: Function,
      default: cell => {}
    },
    tableRowClassName: {
      type: Function,
      default: cell => {}
    },
    showSummary: {
      type: Boolean,
      default: false
    },
    summaryMethod: {
      type: Function,
      default: cell => {}
    },
    // 表头
    cols: {
      type: Array,
      default: () => {
        return []
      }
    },
    // 表格数据
    rows: {
      type: Array,
      default: () => {
        return []
      }
    },
    // 加载动画
    loading: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    // 当前页
    page: {
      type: Number,
      default: () => {
        return 1
      }
    },
    // 总共数量
    count: {
      type: Number,
      default: () => {
        return 0
      }
    },
    // 每页显示数量
    size: {
      type: Number,
      default: () => {
        return 10
      }
    },
    // 每页显示数量选择
    sizes: {
      type: Array,
      default: () => {
        return [5,20, 30, 50]
      }
    },
    onRowClick: {
      type: Function,
      default: row => {}
    },
    // 表格双击
    onRowDBClick: {
      type: Function,
      default: row => {}
    },
    // 选中行
    onSelection: {
      type: Function,
      default: row => {}
    },
    // 分页改变每页显示的数量
    onPaginationSizeChange: {
      type: Function,
      default: size => {}
    },
    // 分页改变页数
    onPaginationPageChange: {
      type: Function,
      default: page => {}
    },
    showPager: {
      type: Boolean,
      default: true
    },
    checkSelectable: {
      type: Function,
      default: row => { return true }
    },
    onSelect: {
      type: Function,
      default: (selection, row) => {}
    },
    reserveSelection: {
      type: Boolean,
      default: true
    },
    continuous: {
      type: Boolean,
      default: false
    },
    // 报表合计行，'合计'代替序号
    reportSummary: {
      type: Boolean,
      default: false
    },
    autoHeight: {
      type: Boolean,
      default: false
    },
    showExpand: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      currentPage: 1,
      tableHeight: this.autoHeight ? 'auto' : '300px',
      currentIndex: 0
    }
  },
  watch: {
    page: {
      immediate: true,
      handler (val) {
        this.currentPage = val
      }
    }
  },
  mounted () {
    // this.handlerHeight()
    if (!this.showPager) {
      this.showPager = false
    }
  },
  methods: {
    mouseLeave (row, handle, i) {
      this.$set(row.imgUrls, i, handle[i].img)
    },
    mouseEnter (row, handle, i) {
      let handleArray = this.cols.find(a => a.prop === 'handle').handle
      let array = []
      for (let index = 0; index < handleArray.length; index++) {
        let ele = handleArray[index]
        if (index === i) {
          array.push(ele.imgHover)
        } else {
          array.push(ele.img)
        }
      }
      this.$set(row, 'imgUrls', array)
    },
    highlightRow (flag) {
      if (flag === 'reset') {
        this.currentIndex = 0
      } else
      if (flag === 'up') {
        this.currentIndex--
      } else {
        this.currentIndex++
      }
      this.$nextTick(() => {
        let array = this.handleIndex(this.rows)
        if (this.currentIndex === 0 || this.currentIndex > array.length - 1) {
          this.currentIndex = 0
          this.$refs.table.setCurrentRow(array[0])
          this.$emit('update:selectRow', array[0])
        } else
        if (this.currentIndex > array.length - 1 || this.currentIndex < 0) {
          this.currentIndex = array.length - 1
          this.$refs.table.setCurrentRow(array[array.length - 1])
          this.$emit('update:selectRow', array[array.length - 1])
        } else {
          let row = array.find(a => a.index === this.currentIndex)
          if (row) {
            this.$refs.table.setCurrentRow(row)
            this.$emit('update:selectRow', row)
          } else {
            this.$emit('update:selectRow', null)
          }
        }
      })
    },
    handleKeyEvent (row) {
      this.currentIndex = row.index
      this.$emit('update:selectRow', row)
    },
    handlerHeight () {
      if (this.autoHeight) {
        return
      }
      this.$nextTick(function () {
        if (Number(document.body.clientWidth) <= 1024) {
          this.tableHeight = 460
        } else {
          this.tableHeight = this.handleHeight()
        }
      })
    },
    handleIndex (row) {
      if (this.continuous) {
        row.map((r, index) => {
          r.index = index + (this.page - 1) * this.size + 1
          if (this.reportSummary && index === row.length - 1) {
            r.index = '合计'
          }
        })
      } else {
        row.map((r, index) => {
          r.index = index
        })
      }
      return row
    },
    handleDisabled (handler, param) {
      if (!handler) {
        return false
      } else if (typeof handler === 'function') {
        return handler(param)
      } else {
        return handler
      }
    },
    handleShow (handler, param) {
      if (typeof handler === 'boolean') {
        return handler
      } else if (typeof handler === 'function') {
        return handler(param)
      } else {
        return true
      }
    },
    handleTitle (title, row) { // 用来处理二选一的操作， 如启用/禁用
      if (typeof title === 'function') {
        return title(row)
      } else {
        return title
      }
    },
    handleStyle (style, row) {
      if (typeof style === 'function') {
        return style(row)
      } else {
        return style
      }
    },
    toggleRowSelection (row, flag) {
      this.$refs.table.toggleRowSelection(row, flag)
    },
    clearSelection () {
      this.$refs.table.clearSelection()
    },
    setCurrentRow (row) {
      this.$refs.table.setCurrentRow(row)
    },
    handleRowExpand (row) {
      this.$refs.table.toggleRowExpansion(row)
    }
  }
}
</script>

<style scoped>
.el-pagination {
  margin-top: 15px;
  padding-bottom: 10px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/cg_tabel/view.vue